// extracted by mini-css-extract-plugin
export default {"banner":"SBdW0MBmZZW0G1zj72gw"};